module.exports = require('./helpers/bundle-url').getBundleURL('4AlMw') + "user-guide.96927433.png" + "?" + Date.now();